import React from 'react';

const WatermarkOverlay = ({ userData }) => {
  const label = `${userData?.name || "User"} ${userData?.email || ""}`.trim();
  const isMobile = typeof window !== "undefined" && window.innerWidth < 640;
  const count = isMobile ? 12 : 18;
  
  return (
    <div className="watermark-layer" aria-hidden="true">
      <div className="watermark-grid">
        {Array.from({ length: count }).map((_, i) => (
          <span key={i} className="watermark-text">
            {label}
          </span>
        ))}
      </div>
    </div>
  );
};

export default WatermarkOverlay;
